// extracted by mini-css-extract-plugin
module.exports = {"bottom-sheet":"bottom_sheet_bottom-sheet__rUeSx","close":"bottom_sheet_close__bhKo7"};